// @noflow
import React, { Component } from 'react';

import bariolBoldTtf from '~/assets/fonts/bariol_bold.ttf';
import bariolBoldWoff from '~/assets/fonts/bariol_bold.woff';
import bariolMediumTtf from '~/assets/fonts/bariol_medium.ttf';
import bariolMediumWoff from '~/assets/fonts/bariol_medium.woff';
import bariolRegularTtf from '~/assets/fonts/bariol_regular.ttf';
import bariolRegularWoff from '~/assets/fonts/bariol_regular.woff';
import { injectGlobal } from 'styled-components';
import ResetCSS from '~/components/reset-css';

export default class extends Component {
    componentWillMount() {
        injectGlobal`
			@font-face {
				font-family: Bariol;
				src: url(${bariolRegularWoff}) format("woff"), url(${bariolRegularTtf}) format("truetype");
			}

			@font-face {
				font-family: Bariol;
				font-weight: 500;
                src: url(${bariolMediumWoff}) format("woff"), url(${bariolMediumTtf}) format("truetype");
			}

			@font-face {
				font-family: Bariol;
				font-weight: bold;
				src: url(${bariolBoldWoff}) format("woff"), url(${bariolBoldTtf}) format("truetype");
			}

			:root {
				font-family: Bariol, Arial;
			}
		`;
    }

    render() {
        return <ResetCSS>{this.props.children}</ResetCSS>;
    }
}



// WEBPACK FOOTER //
// ./src/components/global/index.js